import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CallNative } from '../../../services/EpicContextService/call.native';
import { AxiosPromise } from '../../../utils/axios.promise';
import { CommonConfig } from '../../../configs/config.common';
import { AdsConfig } from '../../../configs/ads.config';
import * as moment from 'moment';
interface ServiceItem {
    type: number;
    img: string;
    name: string;
    extParams: any;
}
@Component
export default class WorkflowClosingDateSummaryPage extends Vue {
    public servicesList: ServiceItem[] = [];
    public commonConfigs = new CommonConfig();
    public finished: any = false;
    public async getService() {
        // const apiHost: string = this.commonConfigs.cimsServHost;
        // const fetched = await AxiosPromise.get(`${apiHost}/bimsEntrust/servicePackage`);
        // if (fetched && fetched.code === 200 && fetched.data) {
        //     this.servicesList = fetched.data.map((v: any) => {
        //         return {
        //             id: v.id,
        //             name: v.x_name,
        //             img: v.x_banner,
        //             type: 2
        //         };
        //     });
        // }
        this.servicesList = new AdsConfig().serviceList;
    }
    public closingDate: string = '';
    public noticeDate: string = '';
    public finishDate: string = '';
    public entrustId: any = null;
    public activityId: any = null;
    @Watch('globalPudge.context', { immediate: true, deep: true })
    public onGlobalPudget(val: any, oldVal: any) {
        const closingDatePair = this.globalPudge.functions.getParam('closingDate');
        this.entrustId = this.globalPudge.functions.getParam('entrustId').value;
        this.activityId = this.globalPudge.functions.getParam('activityId').value;
        if (closingDatePair) {
            const closingDate = closingDatePair.value;
            this.closingDate = moment(closingDate).format('YYYY-MM-DD');
            this.noticeDate = moment(closingDate).subtract(3, 'days').format('YYYY-MM-DD');
            this.finishDate = moment(closingDate).add(1, 'days').format('YYYY-MM-DD');
        }
    }
    public async created() {
        document.title = ' ';
        await this.getService();
        this.finished = this.$route.query['finished'];
    }
    public goService(item: ServiceItem) {
        const params: any = {
            type: item.type,
            name: item.name,
            ...item.extParams
        };
        console.log(params);
        CallNative.runNativeFun(CallNative.ENativeFunctions.NativeGoServer, params);
    }

    public mounted() {
        CallNative.runNativeFun(CallNative.ENativeFunctions.NativeSetNavTitle, {
            'title_cn': '交割详情',
            'title_en': 'Closing Date Detail',
        });
        // CallNative.nativeSetNavTitle('交割详情', 'Closing Date Detail');
    }
    public goNativeWorkflowPage() {
        const entrust = {
            entrustId: parseInt(this.entrustId, 10),
            type: 1
        };
        CallNative.runNativeFun(CallNative.ENativeFunctions.NativeGoWorkflow, entrust);
    }
    public handleMofify() {
        this.$router.replace({
            path: `/hybrid/closing-date/datepicker`, query: {
                entrustId: this.entrustId,
                activityId: this.activityId,
            }
        });
    }
    public handleComplete() {
        CallNative.runNativeFun(CallNative.ENativeFunctions.NativeClose);
    }
}
